import { useState } from 'react';

export function useChallengeState() {
  const [challengeState, setChallengeState] = useState<
    string | null | undefined
  >(null);

  return {
    challengeState,
    setChallengeState,
  };
}
